import { render, staticRenderFns } from "./ProductDiscount.vue?vue&type=template&id=845e41da&"
import script from "./ProductDiscount.vue?vue&type=script&lang=js&"
export * from "./ProductDiscount.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports